<template>
  <v-expansion-panels
    class="mt-8 historical-seasonal-rules"
  >
    <v-expansion-panel class="pa-2">
      <v-expansion-panel-header class="my-4">
        <div>
          <h2 v-html="$t('page-rules.manage.section-historical-seasonal-rules.title')" class="font-weight-regular pb-4"></h2>
          <p v-html="$t('page-rules.manage.section-historical-seasonal-rules.intro')" class="body-2 grey--text text--darken-1 mb-0"></p>
        </div>
      </v-expansion-panel-header>
      <v-expansion-panel-content class="mb-4">
        <seasonal-data-table :place="place" :seasonalBookingRules="seasonalBookingRules" />
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>
<script>
import SeasonalDataTable from './SeasonalDataTable.vue'

export default {
  props: {
    place: {
      type: Object,
      required: true,
    },
    seasonalBookingRules: {
      type: Array,
      required: true,
    },
  },
  components: {
    SeasonalDataTable,
  },
}
</script>
